(function (window) {
    var django = {};

    django.pluralidx = function (n) {
        var v = (n != 1);
        if (typeof(v) == 'boolean') {
            return v ? 1 : 0;
        } else {
            return v;
        }
    };

    django.gettext = function (msgid) {
        var value = window.i18n.catalog[msgid];
        if (typeof(value) == 'undefined') {
            return msgid;
        } else {
            return (typeof(value) == 'string') ? value : value[0];
        }
    };

    django.ngettext = function (singular, plural, count) {
        var value = window.i18n.catalog[singular];
        if (typeof(value) == 'undefined') {
            return (count == 1) ? singular : plural;
        } else {
            return value[django.pluralidx(count)];
        }
    };

    django.gettext_noop = function (msgid) {
        return msgid;
    };

    django.pgettext = function (context, msgid) {
        var value = window.gettext(context + '\x04' + msgid);
        if (value.indexOf('\x04') != -1) {
            value = msgid;
        }
        return value;
    };

    django.npgettext = function (context, singular, plural, count) {
        var value = django.ngettext(context + '\x04' + singular, context + '\x04' + plural, count);
        if (value.indexOf('\x04') != -1) {
            value = django.ngettext(singular, plural, count);
        }
        return value;
    };


    django.interpolate = function (fmt, obj, named) {
        if (named) {
            return fmt.replace(/%\(\w+\)s/g, function (match) {
                return String(obj[match.slice(2, -2)])
            });
        } else {
            return fmt.replace(/%s/g, function (match) {
                return String(obj.shift())
            });
        }
    };


    django.get_format = function (format_type) {
        var value = window.i18n.formats[format_type];
        if (typeof(value) == 'undefined') {
            return format_type;
        } else {
            return value;
        }
    };

    /* add to global namespace */
    window.pluralidx = django.pluralidx;
    window.gettext = django.gettext;
    window.ngettext = django.ngettext;
    window.gettext_noop = django.gettext_noop;
    window.pgettext = django.pgettext;
    window.npgettext = django.npgettext;
    window.interpolate = django.interpolate;
    window.get_format = django.get_format;

})(window);